import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavegacaoComponent } from './navegacao.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    NavegacaoComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule
  ],
  exports: [
    NavegacaoComponent
  ]
})

export class NavegacaoModule { }
